const {getProduct,getProducts} = require('./product');
const graphQlUrl = require('./graphQlUrl');

module.exports = {
  getProduct,
  getProducts,
  getGraphQlUrl: graphQlUrl
}